import request from "@/utils/request.js";
import { YuliActivity } from "./config.js";
import _ from "lodash";

/**
 * 根据碎片id获取碎片详情
 * @param {*} params
 */
export const getFragmentsDetailById = () => {
  return request.get(YuliActivity.fragments);
};

/**
 * 获取储蓄罐Yuli列表
 * @param {*} params
 */
export const getSprintSaving = (params) => {
  return request.get(YuliActivity.sprint_saving, { params });
};

/**
 * 提取arg
 * @param {*} params
 */
export const postSprintSaving = (params) => {
  return request.post(YuliActivity.draw_arg, params);
};

/**
 * 获取储蓄罐成长基金
 * @param {*} params
 */
export const getGrowthReward = () => {
  return request.get(YuliActivity.wallet_arg);
};

/**
 * 获取储蓄罐成长基金配置项
 */
export const getGrowthRewardConfig = () => {
  return request.get(YuliActivity.growth_config);
};

/**
 * 获取储蓄罐成长基金消耗记录
 * @param {*} params
 */
export const getConsumeList = (params) => {
  return request.get(YuliActivity.gr_fund_flow,{params});
};

/**
 * 获取储蓄罐成长基金配置项
 * @param {*} params
 */
export const postGrowthRewardConfig = (params) => {
  return request.post(YuliActivity.growth_config, params);
};
